import { render, staticRenderFns } from "./leadTypeItemData.vue?vue&type=template&id=2e8fdd9c&scoped=true&"
import script from "./leadTypeItemData.vue?vue&type=script&lang=js&"
export * from "./leadTypeItemData.vue?vue&type=script&lang=js&"
import style0 from "./leadTypeItemData.vue?vue&type=style&index=0&id=2e8fdd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fdd9c",
  null
  
)

export default component.exports